// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2009":"ff0ea132","7829":"d5a60d55"}[chunkId] + ".chunk.js";
};